module.exports = {"classes":["notfound-page","theme-dark"],"title":"Not found","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/notfound/metadata.json
// module id = 1664
// module chunks = 0